import { render } from "./BiomarHeaderMobile.vue?vue&type=template&id=192ccc8e&scoped=true&ts=true"
import script from "./BiomarHeaderMobile.vue?vue&type=script&lang=ts"
export * from "./BiomarHeaderMobile.vue?vue&type=script&lang=ts"

import "./BiomarHeaderMobile.vue?vue&type=style&index=0&id=192ccc8e&scoped=true&lang=scss"

import exportComponent from "/home/florian/dev/biomar/vue-starter-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192ccc8e"]])

export default __exports__